import React, { useEffect } from 'react';
import { initMetaPixel } from './utils/metaPixel';
import { UrgencyBanner } from './components/UrgencyBanner';
import { StickyBar } from './components/StickyBar';
import { HeroSection } from './components/HeroSection';
import { PainSection } from './components/PainSection';
import { BenefitsGrid } from './components/BenefitsGrid';
import { WhatItIsSection } from './components/WhatItIsSection';
import { EmpathyStory } from './components/EmpathyStory';
import { ScienceSection } from './components/ScienceSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { ContentPreview } from './components/ContentPreview';
import { OfferSection } from './components/OfferSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { FAQSection } from './components/FAQSection';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
export function App() {
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <div className="min-h-screen bg-cream font-body text-warm-gray selection:bg-sage selection:text-white" data-id="element-0">
      <StickyBar data-id="element-1" />
      <UrgencyBanner data-id="element-2" />

      <main data-id="element-3">
        <HeroSection data-id="element-4" />
        <PainSection data-id="element-5" />
        <BenefitsGrid data-id="element-6" />
        <WhatItIsSection data-id="element-7" />
        <EmpathyStory data-id="element-8" />
        <ScienceSection data-id="element-9" />
        <TestimonialsSection data-id="element-10" />
        <ContentPreview data-id="element-11" />
        <OfferSection data-id="element-12" />
        <GuaranteeSection data-id="element-13" />
        <FAQSection data-id="element-14" />
        <FinalCTA data-id="element-15" />
      </main>

      <Footer data-id="element-16" />
    </div>;
}